import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	LOGOUT,
	LOGIN_AZURE,
	UPDATE_NEW_TOKEN,
	AZUREAD_LOGIN_URL_REQUEST,
	AZUREAD_LOGIN_URL_REQUEST_FAILURE,
	AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR,
	AZUREAD_LOGIN_URL_REQUEST_SUCCESS,
	LOGOUT_USER_SUCCESS,
	LOGOUT_USER_FAILURE,
} from "../types"

let user = JSON.parse(localStorage.getItem("user"))
const initialState = user
	? {
			loggedIn: true,
			user,
			isLoginInStart: false,
			login_error: null,
			azureAdLoginUrl: undefined,
			azureAdLoginUrl_loading: false,
			isLogout: false,
	  }
	: {
			loggedIn: false,
			isLoginInStart: false,
			login_error: null,
			azureAdLoginUrl: undefined,
			azureAdLoginUrl_loading: false,
			isLogout: false,
	  }

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case LOGIN_REQUEST:
			return {
				loggedIn: false,
				user: action.payload.username,
				login_error: null,
			}
		case LOGIN_SUCCESS:
			return {
				loggedIn: true,
				user: action.payload,
				login_error: null,
			}
		case LOGIN_FAILURE:
			return { loggedIn: false, isLoginInStart: false, login_error: action.payload }
		case LOGOUT:
			return { loggedIn: false, isLoginInStart: false }
		case UPDATE_NEW_TOKEN:
			return {
				loggedIn: true,
				user: action.payload,
			}
		case AZUREAD_LOGIN_URL_REQUEST:
			return {
				azureAdLoginUrl_loading: true,
				azureAdLoginUrl: undefined,
			}
		case AZUREAD_LOGIN_URL_REQUEST_SUCCESS:
			return {
				azureAdLoginUrl_loading: false,
				azureAdLoginUrl: action.payload,
			}
		case AZUREAD_LOGIN_URL_REQUEST_FAILURE:
			return {
				azureAdLoginUrl_loading: false,
				error: action.payload,
			}
		case AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR:
			return {
				azureAdLoginUrl_loading: false,
				azureAdLoginUrl: undefined,
				error: undefined,
			}
		case LOGOUT_USER_SUCCESS: {
			return {
				...state,
				isLogout: true,
			}
		}
		case LOGOUT_USER_FAILURE: {
			return {
				...state,
				isLogout: false,
			}
		}

		default:
			return state
	}
}
